import { Injectable, inject } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { ProductActions } from "@core/state/products/products.actions";
import { ProductsDataService } from "@core/services/datasources/products-data.service";
import { createNormalizedError } from "@core/utilities/error-handler.util";


@Injectable({ providedIn: 'root' })
export class ProductsEffects {

  private readonly actions$ = inject(Actions);
  private readonly productsDataService = inject(ProductsDataService);

  constructor() { }

  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.load),
      mergeMap(() => this.productsDataService.getProducts()
        .pipe(
          map(products => ProductActions.loadSuccess({ products })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ProductActions.loadFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  add$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.add),
      map((action) => action.command),
      mergeMap((command) => this.productsDataService.addProduct(command)
        .pipe(
          map(product => ProductActions.addSuccess({ product })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ProductActions.addFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  update$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.update),
      map((action) => action.command),
      mergeMap((command) => this.productsDataService.updateProduct(command)
        .pipe(
          map(product => ProductActions.updateSuccess({ product })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ProductActions.updateFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  remove$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.remove),
      map((action) => action.command),
      mergeMap((command) => this.productsDataService.removeProduct(command.productCode)
        .pipe(
          map(() => ProductActions.removeSuccess({ productCode: command.productCode })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ProductActions.removeFailure({ error: normalizedError }));
          })
        )
      )
    )
  });
}
